module.exports = __webpack_public_path__ + "img/PcContent5.bb2f29c2.png";